export default {
    WINDOW: {
        CLICKED:{}, /* Nicht abgefangene 'mousedown'-Events.
                     * - Alle Felder des 'MouseEvent'",
                     */
        RESIZED:{} /* Wird durch Veränderung des Viewports ausgelöst.
                     * - Alle Felder des 'ResizeEvent'
                     * - width: Neue Breite des Viewports (von 'window')
                     * - height: Neue Höhe des Viewports (von 'window')
                     */
    },
    INPUT_METHOD: {
        CHANGED: {} /* Wird ausgelöst, wenn das NPM-Modul what-input eine Änderung der Eingabemethode
                     * feststellt (z.B. Wechsel von Tablet- in Desktopmodus bei Hybridgeräten wie dem
                     * Microsoft Surface) oder die Seite initial geladen wird.
                     * - 'from': Alte Eingabemethode ('mouse' oder 'touch')
                     * - 'to': Neue Eingabemethode ('mouse' oder 'touch')
                     */
    },
    BREAKPOINT: {
        CHANGED: {} /* Wird bei Änderung des Breakpoints ausgelöst. Aus technischen Gründen wird vorher
                     * ein `window:resized` ausgelöst.
                     * - 'breakpoint': neues 'Breakpoint'-Objekt
                     * -- 'key`: Schlüssel aus der SCSS-$breakpoints-Map (oder `pre-load`).
                     * -- 'value`: Wert aus der SCSS-$breakpoints-Map (oder `null`)
                     */
    },
    ELEMENT: {
        HIDDEN: {}  /* Wird ausgelöst, wenn ein Element geschlossen wird.
                     * - {
                     *       "element": Node  // Das Element, das mittels .hide versteckt wird
                     *       "closer": Node    // Button, der das Schließen verursacht hat
                     *   }
                     */
    },
    DOM: {
        CHANGED: {}
    },
    LAYER: {
        CLOSE_ALL_VISIBLE: {},   /* Event kann geworfen werden um offene Layer zu schließen */
        OPEN: {},    /* Öffnen eines Layers, Config kann übergeben werden
                     * - {
                     *      "config": Object //das Config-Objekt
                     *   }
                     */
        CLOSED: {}
    },
    MINI_SLIDER: {
        SLIDER_MOVE: {},     /* Event kann geworfen werden, um Bewegungen des Mini-Slider zu registrieren */
        UPDATE: {},     /* Event kann geworfen werden, um Mini-Slider bei Änderung der Daten upzudaten */
    },
    DROPDOWN: {
        CLOSE: {} /* Event kann geworfen werden um ein geöffnetes Dropdown zu schließen */
    }
};
